import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Label = (props) => {
    return (
        <label
            className='inline-block border-0 p-0 mb-10 type-style-10'
            {...props}>
            {props.children}
            {props.required &&
                <sup className='text-orange ml-5'>*</sup>
            }
        </label>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

Label.propTypes = {
    children: PropTypes.any,
    required: PropTypes.bool
};

export default Label;
